import { WAITLIST_PATH } from "@/constants/auth";
import { TEAM_CONTACT_EMAIL } from "@/constants/calendar";

/**
 * Public waitlist URL with optional query string preserved (e.g. UTM params).
 */
export function buildWaitlistHref(search: string): string {
  return `${WAITLIST_PATH}${search}`;
}

const ENTERPRISE_CONTACT_MAILTO_SUBJECT = "Paribus — Enterprise / demo inquiry";

/**
 * Prefilled mailto body for enterprise / sales inquiries from the app.
 * Broad, email-style copy; intentionally no name or address lines — the sender’s client supplies identity on send.
 */
export const ENTERPRISE_CONTACT_MAILTO_BODY_TEMPLATE = `Hello,

I'm reaching out to learn more about Paribus and how it might work for our organization. We'd welcome a chance to connect and discuss what could make sense on our side.

Thank you for your time.

Best regards,
`;

/**
 * mailto: link with subject and enterprise inquiry body prefilled.
 */
export function buildTeamMailtoHref(): string {
  const subject = encodeURIComponent(ENTERPRISE_CONTACT_MAILTO_SUBJECT);
  const body = encodeURIComponent(ENTERPRISE_CONTACT_MAILTO_BODY_TEMPLATE);
  return `mailto:${TEAM_CONTACT_EMAIL}?subject=${subject}&body=${body}`;
}
